import type { ApiError } from '@/types/api.types'

/**
 * Error code erp-api returns (HTTP 402) when the workspace has no entitlement
 * for the feature behind the endpoint — distinct from `plan_limit_exceeded`,
 * which means the add-on is owned but a usage quota is exhausted.
 */
export const FEATURE_NOT_ENABLED_CODE = 'feature_not_enabled'

export function isFeatureNotEnabledError(
  err: unknown,
): err is ApiError & { code: typeof FEATURE_NOT_ENABLED_CODE } {
  if (!err || typeof err !== 'object') return false
  const candidate = err as ApiError
  return candidate.status === 402 && candidate.code === FEATURE_NOT_ENABLED_CODE
}

/** Feature key an entitlement rejection refers to, when the server sent one. */
export function featureKeyFromError(err: unknown): string | undefined {
  if (!isFeatureNotEnabledError(err)) return undefined
  const feature = err.feature
  return typeof feature === 'string' && feature ? feature : undefined
}
